import type { IndexedList } from "storefront/lib/IndexedList";

export type Assets = {
  images: IndexedList<string>;
};

const assets = ({ grailed }: typeof window): Assets => grailed.assets;

export default assets;
